"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseResponsePropertiesToJSON = exports.BaseResponsePropertiesFromJSONTyped = exports.BaseResponsePropertiesFromJSON = exports.instanceOfBaseResponseProperties = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the BaseResponseProperties interface.
 */
function instanceOfBaseResponseProperties(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfBaseResponseProperties = instanceOfBaseResponseProperties;
function BaseResponsePropertiesFromJSON(json) {
    return BaseResponsePropertiesFromJSONTyped(json, false);
}
exports.BaseResponsePropertiesFromJSON = BaseResponsePropertiesFromJSON;
function BaseResponsePropertiesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'draftHierarchyVersion': !(0, runtime_1.exists)(json, 'draft_hierarchy_version') ? undefined : json['draft_hierarchy_version'],
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
    };
}
exports.BaseResponsePropertiesFromJSONTyped = BaseResponsePropertiesFromJSONTyped;
function BaseResponsePropertiesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'draft_hierarchy_version': value.draftHierarchyVersion,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
exports.BaseResponsePropertiesToJSON = BaseResponsePropertiesToJSON;
